$(function() {
  /* Fancybox */
  if ($('.fancybox').fancybox) {
    $(".fancybox").fancybox();
  }
});